// eslint-disable-next-line @typescript-eslint/naming-convention
export const LoadingImageHeader = 'x-loading-image';

export interface ILoadingOptions {
  loading: boolean;
  loadingImage?: string;
  authorization?: string;
}
